import React from "react";
import {FormHelperText} from "@material-ui/core";
import {MenuItem, Select, InputLabel, FormControl} from "@mui/material";

export default (data, key) => {
    return (<FormControl style={{margin: '10px 0'}} fullWidth key={key} error={data.error ? true : false}>
        <InputLabel id="simple-select-helper-label" htmlFor="input-with-icon-adornment">
            {data.label}
        </InputLabel>
        <Select
            labelId="simple-select-helper-label"
            fullWidth
            error={data.error ? true : false}
            id={`${data.name}-${key}`}
            value={data.value}
            label={data.label}
            name={data.name}
            onChange={data.onCallback}
        >
            {data.items.map((val, ind) => (<MenuItem key={ind} value={val}>{val}</MenuItem>))}
        </Select>
        {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
    </FormControl>)
}
